import { initializeApp } from "firebase/app";
import { getDatabase, ref, push, onChildAdded, query, orderByChild, limitToLast, get } from "firebase/database";
import {
    apiKey,
    appId,
    messageId,
    authDomainKey,
    proyectId,
    storageBucket,
    databaseURL
  } from "./config"; // import sensible information

// Configuración de Firebase (sustituye con tus credenciales reales)
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomainKey,
  projectId: proyectId,
  databaseURL: databaseURL,
  storageBucket: storageBucket,
  messagingSenderId: messageId,
  appId: appId,
};

// Inicializa la aplicación Firebase
const app = initializeApp(firebaseConfig);

// Obtiene la instancia de la base de datos correctamente
const db = getDatabase(app);

export const getLastMessage = async (chatId) => {
  const chatRef = ref(db, `chats/${chatId}`);
  const lastMsgQuery = query(chatRef, orderByChild("timestamp"), limitToLast(1));

  try {
    const snapshot = await get(lastMsgQuery);
    if (snapshot.exists()) {
      const data = snapshot.val();
      const lastKey = Object.keys(data)[0]; // solo hay uno
      const lastMessage = data[lastKey];/* 
      console.log("Último mensaje:", lastMessage); */
      return lastMessage;
    } else {/* 
      console.log("No hay mensajes"); */
      return null;
    }
  } catch (error) {/* 
    console.error("Error al obtener el último mensaje:", error); */
    return null;
  }
};

export { db, ref, push, onChildAdded };

